<div class="wrapper confinement">
  <div class="back-link-container content-box-only-width">
    <a routerLink=".." class="back-on-mobile mat-h2 back-link">
      <mat-icon class="back-link-icon">arrow_back</mat-icon>{{ 'DASHBOARD.MODIFY_DATA' | translate }}
    </a>
  </div>
  <mat-card class="confinement">
    <mat-card-title>{{ 'ACCOUNT.CHANGE_PHONE_NUMBER.TITLE' | translate }}</mat-card-title>
    <mat-card-content>
      <div>
        <p class="break-word-on-overflow">
          {{ 'ACCOUNT.CHANGE_PHONE_NUMBER.CURRENT_PHONE_NUMBER' | translate }}:&nbsp;{{
            currentPhoneNumber$ | async | replaceEmptyWithString : '-'
          }}
        </p>
      </div>
      @let formState = changePhoneNumberFormState$ | async; @if(formState) {
      <div class="form-container">
        <form (keydown.enter)="$event.preventDefault(); onSubmit(formState)">
          <cover-select-country
            appearance="fill"
            selectionMode="phoneCode"
            [showCallingCode]="true"
            [itemsLoadSize]="5"
            [initialCountries]="initCountries"
            [objectValue]="{
              alpha2Code: '',
              name: '',
              alpha3Code: '',
              numericCode: '',
              callingCode: ''
            }"
            label="{{ 'ACCOUNT.ADD_ADDRESS.COUNTRY' | translate }}"
            (countrySelected)="changeSelectedCountry($event)"
          />
          <mat-form-field class="form-field" appearance="fill">
            <mat-label>{{ 'ACCOUNT.CHANGE_PHONE_NUMBER.NEW_PHONE_NUMBER' | translate }}</mat-label>
            <input
              matInput
              type="tel"
              inputmode="numeric"
              pattern="[0-9]*"
              [ngrxFormControlState]="formState"
              maxlength="60"
              (input)="onPhoneNumberInput($event, formState)"
            />
          </mat-form-field>
        </form>
        <div class="submit-button-wrapper">
          <button
            type="button"
            mat-flat-button
            color="primary"
            (click)="onSubmit(formState)"
            [class.button-spinner]="this.pending"
            [disabled]="this.pending"
          >
            {{ 'GENERAL.SAVE_CHANGE' | translate }}
          </button>
        </div>
      </div>
      }
    </mat-card-content>
  </mat-card>
</div>
